import { useTranslation } from "react-i18next";
import { Skeleton } from "primereact/skeleton";

const UserDetailsSkeleton = () => {
	const { t } = useTranslation();

	return (
		<div className="grid columns-3 gapCol-medium">
			<div className="grid columns-label gapCol-medium gapRow-xsmall aItems-center aContent-start">
				<span>{t("user.common.fullname")}:</span>
				<span>
					<Skeleton width="75%" />
				</span>
				<span>{t("user.common.email")}:</span>
				<span>
					<Skeleton width="85%" />
				</span>
				<span>{t("user.common.role")}:</span>
				<span>
					<Skeleton width="65%" />
				</span>
			</div>
			<div className="grid columns-label gapCol-medium gapRow-xsmall aItems-center aContent-start">
				<span>{t("user.common.active")}:</span>
				<span>
					<Skeleton width="45%" />
				</span>
				<span>{t("user.details.form.status")}:</span>
				<span>
					<Skeleton width="85%" />
				</span>
				<span>{t("user.details.form.mfa")}:</span>
				<span>
					<Skeleton width="65%" />
				</span>
			</div>
			<div className="grid columns-label gapCol-medium gapRow-xsmall aItems-center aContent-start">
				<span>{t("common.table.createdAt")}:</span>
				<span>
					<Skeleton width="75%" />
				</span>
				<span>{t("common.table.updatedAt")}:</span>
				<span>
					<Skeleton width="85%" />
				</span>
			</div>
		</div>
	);
};

export default UserDetailsSkeleton;
